import { render, staticRenderFns } from "./AddTaskForm.vue?vue&type=template&id=06dca7b0&"
import script from "./AddTaskForm.vue?vue&type=script&lang=js&"
export * from "./AddTaskForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports